var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldGrid3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2v11.75H22V7.81C22 4.17 19.83 2 16.19 2h-3.44zM2 15.25v.94C2 19.83 4.17 22 7.81 22h3.44V10.25H2v5zM11.25 8.75H2v-.94C2 4.17 4.17 2 7.81 2h3.44v6.75zM22 16.19c0 3.64-2.17 5.81-5.81 5.81h-3.44v-6.75H22v.94z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGrid3);
export default __webpack_public_path__ + "static/media/vuesax-bold-grid-3.7ef8e7041a2cc75e97c818416a56546c.svg";
export { ForwardRef as ReactComponent };